import { Panel, Modal } from '@studiometa/ui';
import VariantRadios from './ProductInfo/VariantRadios.js';

/**
 * QuickAddToCartPanel component
 */
export default class QuickAddToCartPanel extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'QuickAddToCartPanel',
    refs: [...Modal.config.refs, 'content'],
    components: {
      VariantRadios,
    },
  };

  /**
   * On document openaddtocartpanel
   * @param {object} props
   * @param {object} props.event
   */
  async onWindowAddpanel({ event }) {
    const productId = event.detail.product;

    try {
      console.log('productId', productId);
      this.setLoadingState(true);
      const productHtml = await this.fetchProductTemplate(productId);
      this.updatePanelContent(productHtml);
      this.open();
    } catch (error) {
      console.error('Error fetching product template:', error);
    } finally {
      this.setLoadingState(false);
    }
  }

  /**
   * Fetch product template using Shopify Section Rendering API
   * @param {string|number} productId The product ID or handle
   * @returns {Promise<string>} The HTML content
   */
  async fetchProductTemplate(productId) {
    const pathSegment = window.location.pathname.split('/').find(Boolean);
    const firstSegment = pathSegment;

    const shopifyPrefixes = [
      'collections',
      'products',
      'pages',
      'blogs',
      'cart',
      'account',
      'search',
      'policies',
    ];

    const languagePath =
      firstSegment && !shopifyPrefixes.includes(firstSegment) ? firstSegment : '';

    const url = languagePath
      ? `/${languagePath}?section_id=quick-add-product&product_id=${productId}`
      : `/?section_id=quick-add-product&product_id=${productId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.text();
  }

  /**
   * Update the panel content with fetched HTML
   * @param {string} html The HTML content to insert
   */
  updatePanelContent(html) {
    const contentContainer = this.$refs.content;
    contentContainer.innerHTML = html;

    setTimeout(() => {
      this.$root.$update();
    }, 0);
  }

  /**
   * Set loading state
   * @param {boolean} isLoading
   */
  setLoadingState(isLoading) {
    if (isLoading) {
      this.$el.classList.add('is-loading');
    } else {
      this.$el.classList.remove('is-loading');
    }
  }
}
